"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotRetryableError = exports.RetryError = exports.notEmpty = exports.customizeRetry = exports.customizeDecorator = exports.retryDecorator = exports.retry = exports.wait = exports.defaultRetryConfig = void 0;
var timeout_1 = require("./timeout");
var fixedBackoff = function (attempt, delay) { return delay; };
var linearBackoff = function (attempt, delay) { return attempt * delay; };
var exponentialBackoff = function (attempt, delay) { return Math.pow(delay, attempt); };
exports.defaultRetryConfig = {
    backoff: "FIXED",
    delay: 100,
    logger: function () { return undefined; },
    maxBackOff: 5 * 60 * 1000,
    retries: 10,
    timeout: 60 * 1000,
    until: function () { return true; },
    retryIf: function () { return true; }
};
function wait(ms) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve) { return setTimeout(resolve, ms); })];
        });
    });
}
exports.wait = wait;
function retry(f, config) {
    return __awaiter(this, void 0, void 0, function () {
        var effectiveConfig;
        return __generator(this, function (_a) {
            effectiveConfig = Object.assign({}, exports.defaultRetryConfig, config);
            return [2 /*return*/, timeout_1.timeout(effectiveConfig.timeout, function (done) { return _retry(f, effectiveConfig, done); })];
        });
    });
}
exports.retry = retry;
function retryDecorator(func, config) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return retry(function () { return func.apply(void 0, args); }, config);
    };
}
exports.retryDecorator = retryDecorator;
function customizeDecorator(customConfig) {
    return function (args, config) { return retryDecorator(args, Object.assign({}, customConfig, config)); };
}
exports.customizeDecorator = customizeDecorator;
// tslint:disable-next-line
function customizeRetry(customConfig) {
    return function (f, c) {
        var customized = Object.assign({}, customConfig, c);
        return retry(f, customized);
    };
}
exports.customizeRetry = customizeRetry;
function _retry(f, config, done) {
    return __awaiter(this, void 0, void 0, function () {
        var lastError, delay, retries, i, result, error_1, millisToWait;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    switch (config.backoff) {
                        case "EXPONENTIAL":
                            delay = exponentialBackoff;
                            break;
                        case "FIXED":
                            delay = fixedBackoff;
                            break;
                        case "LINEAR":
                            delay = linearBackoff;
                            break;
                        default:
                            delay = config.backoff;
                    }
                    if (config.retries === "INFINITELY") {
                        retries = Number.MAX_SAFE_INTEGER;
                    }
                    else {
                        retries = config.retries;
                    }
                    i = 0;
                    _a.label = 1;
                case 1:
                    if (!(i <= retries)) return [3 /*break*/, 8];
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, f()];
                case 3:
                    result = _a.sent();
                    if (config.until(result)) {
                        return [2 /*return*/, result];
                    }
                    config.logger("Until condition not met by " + result);
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    if (!config.retryIf(error_1)) {
                        throw error_1;
                    }
                    if (error_1.name === NotRetryableError.name) {
                        throw new RetryError("Met not retryable error. Last error: " + error_1, error_1);
                    }
                    lastError = error_1;
                    config.logger("Retry failed: " + error_1.message);
                    return [3 /*break*/, 5];
                case 5:
                    millisToWait = delay(i + 1, config.delay);
                    return [4 /*yield*/, wait(millisToWait > config.maxBackOff ? config.maxBackOff : millisToWait)];
                case 6:
                    _a.sent();
                    if (done()) {
                        return [3 /*break*/, 8];
                    }
                    _a.label = 7;
                case 7:
                    i++;
                    return [3 /*break*/, 1];
                case 8: throw new RetryError("All retries failed. Last error: " + lastError, lastError);
            }
        });
    });
}
exports.notEmpty = function (result) {
    if (Array.isArray(result)) {
        return result.length > 0;
    }
    return result !== null && result !== undefined;
};
var RetryError = /** @class */ (function (_super) {
    __extends(RetryError, _super);
    /*  istanbul ignore next  */
    function RetryError(message, lastError) {
        var _this = _super.call(this, message) || this;
        _this.lastError = lastError;
        return _this;
    }
    return RetryError;
}(Error));
exports.RetryError = RetryError;
// tslint:disable-next-line:max-classes-per-file
var BaseError = /** @class */ (function () {
    function BaseError() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        Error.apply(this, args);
    }
    return BaseError;
}());
BaseError.prototype = new Error();
// tslint:disable-next-line:max-classes-per-file
var NotRetryableError = /** @class */ (function (_super) {
    __extends(NotRetryableError, _super);
    function NotRetryableError(message) {
        var _this = _super.call(this, message) || this;
        Object.defineProperty(_this, 'name', { value: _this.constructor.name });
        return _this;
    }
    return NotRetryableError;
}(BaseError));
exports.NotRetryableError = NotRetryableError;
//# sourceMappingURL=retry-promise.js.map